<template>
    <div>
        <template v-if="label">
            <label :for="id" class="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
                {{ label }}
            </label>
        </template>
        <select
            :id="id"
            v-model="selection"
            :name="id"
            :disabled="disabled"
            class="tw-transition-colors tw-duration-300 tw-block tw-w-full tw-pl-3 tw-pr-10 tw-py-2 tw-text-base tw-truncate tw-bg-gray-100 tw-border-transparent focus:tw-outline-none focus:tw-ring-indigo-500 focus:tw-border-indigo-500 tw-border-0 tw-border-b-2 xl:tw-text-sm tw-appearance-none"
            @change="onChange"
            @blur="$emit('blur', $event.target.value)"
        >
            <optgroup v-for="(groupValue, groupKey) in data" :key="groupKey" :label="$t(groupKey)">
                <option
                    v-for="(optionValue, optionKey) in groupValue"
                    :key="optionKey"
                    :selected="selection === optionKey"
                    :value="optionKey"
                >
                    {{ typeof optionValue === "object" ? optionValue.name : optionValue }}
                </option>
            </optgroup>
        </select>
    </div>
</template>

<script>
import generateDefaultId from "@/utils/generate-default-id";

export default {
    props: {
        label: {
            type: String,
            default: "",
        },
        id: {
            type: String,
            default() {
                return generateDefaultId();
            },
        },
        value: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                groupLabel1: {
                    value1: "name1",
                    value2: "name2",
                },
                groupLabel2: {
                    value3: "name3",
                },
            }),
        },
    },
    data() {
        return {
            selection: null,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.selection = value;
            },
        },
    },
    methods: {
        onChange(e) {
            this.$emit("change", e);
            this.$emit("update:value", e.target.value);
        },
    },
};
</script>

<style scoped>
/** base style reset, replacing bootstrap */
select {
    background-image: url("data:image/svg+xml;utf8,<svg fill='rgb(158, 158, 158)' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
    background-position: right 0.5rem center;
    background-repeat: no-repeat;
    background-size: 1.5em 1.5em;
    padding-right: 2.5rem;
    color-adjust: exact;
}
</style>
